<template>
  <v-app>
    <router-view />

    <!-- Global toast -->
    <v-snackbar
      v-model="$toast.state.show"
      :timeout="$toast.state.timeout"
      :color="$toast.state.color"
      location="bottom"
      elevation="6"
    >
      {{ $toast.state.message }}
      
      <template v-slot:actions>
        <v-btn
          color="white"
          variant="text"
          @click="$toast.state.show = false"
        >
          {{ $t('toast.close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>

import { useTheme } from 'vuetify'

export default {
  name: 'App',


  created(){
    this.theme = useTheme()
    // Set initial theme from store
    // this.$vuetify.theme.global.name = this.store.darkTheme ? 'dark' : 'light'
    this.$vuetify.theme.change(this.store.darkTheme ? 'dark' : 'light')
  },

  mounted(){
    console.log('Current theme:', this.$vuetify.theme.current)
    console.log('Available themes:', Object.keys(this.$vuetify.theme.themes))
  },

  watch: {
    'store.darkTheme'(newValue) {
      console.log(`App > watch > store.darkTheme > new value ${newValue}`)
      this.$vuetify.theme.change(newValue ? 'dark' : 'light')
    }
  }
}
</script>

<style>
/* Stiluri globale dacă ai nevoie */
.clickable-area:hover {
  background-color: rgba(var(--v-theme-primary), 0.05);
  cursor: pointer;
}
</style>
